import { render, staticRenderFns } from "./BaseHero.vue?vue&type=template&id=2a1aa168&"
import script from "./BaseHero.vue?vue&type=script&lang=js&"
export * from "./BaseHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports